import { CODE_DELIMITER } from '../constants';

/**
 * Utility to parse a delimited code into its three pieces
 *
 * @param {String} qualifiedCode
 * @param {String} delimiter
 * @return {Object}
 */
export const parseCode = (qualifiedCode, delimiter = CODE_DELIMITER) => {
  const parts = qualifiedCode.split(delimiter);
  if (parts.length !== 3) {
    throw new Error('Malformed code');
  }

  return {
    campaignId: parts[0],
    number: parseInt(parts[1], 10),
    code: parts[2],
  };
};

/**
 * Converts a parsed code back into a string
 *
 * @param {Object} code - object containing code parts
 * @param {String} code.campaignId - the id of the campaign
 * @param {Number} code.number - the 1-indexed code number
 * @param {String} code.code - the raw signature
 * @return {String} - the fully qualified code
 */
export const stringifyCode = ({ campaignId, number, code }, delimiter = CODE_DELIMITER) =>
  [campaignId, number, code].join(delimiter);



// WEBPACK FOOTER //
// ./src/utilities/codeParser.js